import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721e0ea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-content-between no-margin" }
const _hoisted_2 = { class: "border width-48" }
const _hoisted_3 = { class: "row no-margin" }
const _hoisted_4 = { class: "border-bottom d-flex flex-row align-items-center justify-content-between" }
const _hoisted_5 = { class: "width-50" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["for"]
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = { class: "border-top align-items-center" }
const _hoisted_11 = { class: "border width-48" }
const _hoisted_12 = { class: "row no-margin" }
const _hoisted_13 = { class: "border-bottom d-flex flex-row align-items-center justify-content-between" }
const _hoisted_14 = { class: "width-50" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["for"]
const _hoisted_18 = ["id", "value"]
const _hoisted_19 = { class: "border-top align-items-center" }

import { ElInput, ElScrollbar, ElButton } from "element-plus";
import { ref, computed, onMounted } from "vue";
import { cloneDeep } from "lodash-es";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, getResolution } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'Transfer',
  props: {
    sourceName: {},
    targetName: {},
    items: {},
    selectedItems: {},
    panelHeight: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const panelHeightNormalized = computed(() =>
  typeof props.panelHeight === "number"
    ? `${props.panelHeight}px`
    : props.panelHeight || "23vh"
);

const emit = __emit;

const searchLeft = ref("");
const selectedLeftList = ref([]);

// `items` is typed as required, but a caller feeding it straight from a failed service call can
// still hand us undefined; normalize once so every consumer below stays array-safe.
const sourceItems: any = computed(() => props.items ?? []);

const leftItems: any = computed(() => {
  if (selectedItems.value.length !== 0) {
    return cloneDeep(
      sourceItems.value.filter(
        (item: any) =>
          selectedItems.value.findIndex(
            (selectedItem) => item.id === selectedItem.id
          ) === -1
      )
    );
  }
  return cloneDeep(sourceItems.value);
});

const searchRight = ref("");
const selectedRightList = ref([]);

const selectedItems = ref([]);

function selectAllLeft() {
  if (leftItems.value.length === selectedLeftList.value.length) {
    selectedLeftList.value = [];
  } else {
    selectedLeftList.value = [];
    leftItems.value.forEach((item: any) => {
      selectedLeftList.value.push(item.id);
    });
  }
}

function selectAllRight() {
  if (selectedItems.value.length === selectedRightList.value.length) {
    selectedRightList.value = [];
  } else {
    selectedRightList.value = [];
    selectedItems.value.forEach((item: any) => {
      selectedRightList.value.push(item.id);
    });
  }
}
function selectButtonLabel(side) {
  const isRightSide = side === "right";
  const selectedList = isRightSide
    ? selectedRightList.value
    : selectedLeftList.value;
  const allItems = isRightSide ? selectedItems.value : leftItems.value;

  if (selectedList.length !== allItems.length) {
    return "Select All";
  }
  if (selectedList.length !== 0 || allItems.length !== 0) {
    return "Clear";
  }
  return null;
}

function addToSelectedItems() {
  if (selectedLeftList.value.length !== 0) {
    sourceItems.value.forEach((item: any) => {
      selectedLeftList.value.forEach((selectedItem) => {
        if (item.id === selectedItem) {
          selectedItems.value.push(item);
        }
      });
    });
    selectedLeftList.value = [];
    emit("update", selectedItems.value);
  }
}

function removeFromSelectedItems() {
  if (selectedRightList.value.length !== 0) {
    selectedRightList.value.forEach((selectedItem) => {
      const index = selectedItems.value.findIndex(
        (item) => item.id === selectedItem
      );
      if (index !== -1) {
        selectedItems.value.splice(index, 1);
      }
    });
    selectedRightList.value = [];
    emit("update", selectedItems.value);
  } else {
    selectedItems.value = [];
    emit("update", selectedItems.value);
  }
}

onMounted(() => {
  selectedItems.value = props.selectedItems ? props.selectedItems : [];
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.sourceName) + " ", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ElInput), {
              class: "mt-2 mb-2",
              modelValue: searchLeft.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchLeft).value = $event)),
              size: "small",
              placeholder: _unref(t)('Common.Search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createVNode(_unref(ElScrollbar), {
          height: panelHeightNormalized.value,
          class: "padding-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftItems.value.filter(
              (data) =>
                !searchLeft.value ||
                data.name.toLowerCase().includes(searchLeft.value.toLowerCase())
            ), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mt-1 mb-1 d-flex align-items-center justify-content-between transfer-item", {
              'transfer-item-selected': selectedLeftList.value.includes(item.id),
            }]),
                key: index
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "logo-24",
                    src: `${_unref(ASSETS_BASE_URL)}/${
                  item.connectorSpecId
                }${_unref(getResolution)(false)}.png`,
                    alt: "logo"
                  }, null, 8, _hoisted_7),
                  _createElementVNode("label", {
                    for: 'transfer-check-left-' + index,
                    class: "margin-left-5 cursor-pointer"
                  }, _toDisplayString(item.name), 9, _hoisted_8)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "cursor-pointer",
                  id: 'transfer-check-left-' + index,
                  value: item.id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedLeftList).value = $event))
                }, null, 8, _hoisted_9), [
                  [_vModelCheckbox, selectedLeftList.value]
                ])
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["height"]),
        _createElementVNode("div", _hoisted_10, [
          (selectButtonLabel('left'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "float-start mt-2 mb-2",
                size: "mini",
                onClick: selectAllLeft
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(selectButtonLabel("left")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg float-end mt-2 mb-2",
            size: "mini",
            id: "transfer-add-left-button",
            onClick: addToSelectedItems,
            disabled: selectedLeftList.value.length === 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.targetName) + " ", 1),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(ElInput), {
              class: "mt-2 mb-2",
              modelValue: searchRight.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchRight).value = $event)),
              size: "small",
              placeholder: _unref(t)('Common.Search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createVNode(_unref(ElScrollbar), {
          height: panelHeightNormalized.value,
          class: "padding-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value.filter(
              (data) =>
                !searchRight.value ||
                data.name.toLowerCase().includes(searchRight.value.toLowerCase())
            ), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mt-1 mb-1 d-flex align-items-center justify-content-between transfer-item", {
              'transfer-item-selected': selectedRightList.value.includes(item.id),
            }]),
                key: index
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    class: "logo-24",
                    src: `${_unref(ASSETS_BASE_URL)}/${
                  item.connectorSpecId
                }${_unref(getResolution)(false)}.png`,
                    alt: "logo"
                  }, null, 8, _hoisted_16),
                  _createElementVNode("label", {
                    for: 'transfer-check-right-' + index,
                    class: "margin-left-5 cursor-pointer"
                  }, _toDisplayString(item.name), 9, _hoisted_17)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "cursor-pointer",
                  id: 'transfer-check-right-' + index,
                  value: item.id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedRightList).value = $event))
                }, null, 8, _hoisted_18), [
                  [_vModelCheckbox, selectedRightList.value]
                ])
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["height"]),
        _createElementVNode("div", _hoisted_19, [
          (selectButtonLabel('right'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "float-end mt-2 mb-2",
                size: "mini",
                onClick: selectAllRight
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(selectButtonLabel("right")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg float-start mt-2 mb-2",
            size: "mini",
            id: "transfer-remove-right-button",
            style: {"margin-left":"0 !important"},
            onClick: removeFromSelectedItems,
            disabled: selectedRightList.value.length === 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "arrow-left" })
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})